import styled from 'styled-components'

export const PasswordValidationContainer = styled.div`
  height: 100vh;
  background-color: #24263c;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const MainContainer = styled.div`
  background-color: #383a4e;
  width: 500px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 2px 4px 0px #434451;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Heading = styled.h1`
  font-size: 32px;
  font-family: 'Roboto';
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 10px;
`
export const Paragraph = styled.p`
  font-size: 12px;
  font-family: 'Roboto';
  font-weight: 600;
  color: #f8fafc;
  margin-bottom: 40px;
`
export const Input = styled.input`
  width: 80%;
  padding: 5px 20px;
  outline: none;
  background-color: #edeeff;
`
export const ErrorMsg = styled.p`
  font-size: 17px;
  font-family: 'Roboto';
  font-weight: 500;
  color: #ef4444;
`
